import { useRouter } from 'vue-router';


export const useQueryURL = async (query: { [Key: string]: string }) => {
  const router = useRouter();

  await router.replace({
    query
  });
}
